<!-- MODAL seleccionarRecorrido -->
<div mdbModal #seleccionarRecorrido="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Seleccionar recorrido
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="seleccionarRecorrido.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]='formHeader' novalidate>
                    <div class="row">
                        <div class="col dato">
                            <div class="md-form">
                                <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Código"
                                    formControlName="codigoRecorrido" onlyNumbers />
                                <label for="descRecorrido">Código de recorrido</label>
                            </div>
                        </div>
                        <div class="col dato">
                            <div class="md-form">
                                <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Chofer"
                                    formControlName="chofer" formatRut />
                                <label for="descRecorrido">Chofer</label>
                            </div>
                        </div>
                        <div class="col dato">
                            <div class="md-form">
                                <mdb-date-picker [inline]="true" name="fecha" [placeholder]="'Fecha salida'"
                                    formControlName="fecha" #dpFecha>
                                </mdb-date-picker>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
                        <div></div>
                        <button mdbBtn type="button" size="sm" class="btn btn-sm" color="secondary" mdbWavesEffect (click)="buscar(1)">
                            <mdb-icon fas icon="search"></mdb-icon>
                            Buscar
                        </button>
                    </div>
                </form>

                <table class="table table-striped table-hover table-sm align-middle mt-1"
                    *ngIf="listaRecorridos">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col">Código</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Chofer</th>
                            <th scope="col">Fecha</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="loading">
                            <td colspan="100%" style="text-align: center">
                                <mdb-spinner spinnerColor="blue"></mdb-spinner>
                            </td>
                        </tr>
                        <tr *ngIf="!loading && listaRecorridos?.length === 0">
                            <td colspan="100%" style="text-align: center">
                                No se encontró información
                            </td>
                        </tr>
                        <tr *ngFor="let recorrido of listaRecorridos">
                            <td>{{recorrido.codigo}}</td>
                            <td>{{recorrido.camion_patente}}</td>
                            <td>{{recorrido.rutChoferFormato | rut}}</td>
                            <td>{{recorrido.fecha | fecha}}</td>
                            <td class="text-right">
                                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                                    (click)="seleccionar(recorrido)">
                                    Seleccionar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaRecorridos?.length > 0"></app-pagination>
                </table>
            </div>
        </div>
    </div>
</div>
